import React from "react";

// Import the Klaviyo Newsletter component
import { KlaviyoNewsletter } from "../KlaviyoNewsletter";
import { NewsletterProps } from "./Newsletter.types";

const Newsletter: React.FC<NewsletterProps> = ({
  klaviyoListId,
  showNameFields = false, // Default to showing name fields for better personalization
  placeholder = "Enter your email address",
  buttonText = "Subscribe",
  successMessage = "Thank you for subscribing to our newsletter!",
  label = "Subscribe to our newsletter",
  className,
}) => {
  return (
    <KlaviyoNewsletter
      listId={klaviyoListId}
      showNameFields={showNameFields}
      placeholder={placeholder}
      label={label}
      buttonText={buttonText}
      successMessage={successMessage}
      className={className}
    />
  );
};

export default Newsletter;
